var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallpaperIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 158.756,
    height: 155.76,
    viewBox: "0 0 158.756 155.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M125.806,607.91H14.977a14.977,14.977,0,0,1,0-29.954h5.991V524.039h5.991v59.907H14.977a8.986,8.986,0,0,0,0,17.973h110.83Z",
    transform: "translate(0 -464.131)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M5.991,556.687H0V442.862a15,15,0,0,1,14.977-14.977H26.958v62.9H20.967V433.876H14.977a9,9,0,0,0-8.986,8.986Z",
    transform: "translate(0 -427.885)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M173.254,580.725H158.277v-5.991h8.986V457.914H38.462v-5.991H173.254Z",
    transform: "translate(-14.498 -436.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112",
    "data-name": "Rectangle 112",
    width: 23.963,
    height: 5.991,
    transform: "translate(104.838 2.996)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    "data-name": "Rectangle 113",
    width: 5.991,
    height: 5.991,
    transform: "translate(134.793 2.996)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M215.088,608.589H203.107a6,6,0,0,1-5.991-5.991V518.019L209.1,494.056l11.982,23.963V602.6a6,6,0,0,1-5.991,5.991m-11.982-89.154V602.6h11.987l-.006-83.163L209.1,507.453Z",
    transform: "translate(-74.305 -452.829)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 17.972,
    height: 5.991,
    transform: "translate(125.806 62.904)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M126.051,624.925H100.171A8.828,8.828,0,0,1,95.6,608.547c4.744-2.832,14.386-7.585,25.7-7.585h20.968a8.986,8.986,0,1,1,0,17.972h-1.755a7.184,7.184,0,0,0-5.113,2.118,13.133,13.133,0,0,1-9.349,3.873M121.3,606.953c-9.875,0-18.414,4.221-22.626,6.737a2.771,2.771,0,0,0-1.337,2.41,2.839,2.839,0,0,0,2.835,2.835h25.879a7.185,7.185,0,0,0,5.113-2.118,13.135,13.135,0,0,1,9.349-3.873h1.755a3,3,0,1,0,0-5.991Z",
    transform: "translate(-34.434 -493.128)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M63.662,595.521l-1.89-5.687c.389-.129,39.463-12.912,87.32-12.912v5.991c-46.9,0-85.053,12.481-85.43,12.607",
    transform: "translate(-23.286 -484.066)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M70.857,541.86a17.992,17.992,0,0,1-17.972-17.972c0-4.906.5-47.926,17.972-47.926s17.972,43.02,17.972,47.926A17.992,17.992,0,0,1,70.857,541.86m0-59.908c-7.4,0-11.982,21.767-11.982,41.936a11.982,11.982,0,0,0,23.963,0c0-20.169-4.581-41.936-11.982-41.936",
    transform: "translate(-19.935 -446.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    width: 5.991,
    height: 12.511,
    transform: "translate(47.926 92.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 5.991,
    height: 12.95,
    transform: "translate(74.885 86.866)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M155.418,538.311c-5.754,0-10.724-4.756-13.3-12.724l5.7-1.837c1.679,5.207,4.657,8.571,7.592,8.571,4.25,0,8.986-7.38,8.986-17.973s-4.736-17.972-8.986-17.972c-2.935,0-5.915,3.364-7.592,8.571l-5.7-1.837c2.568-7.968,7.538-12.724,13.3-12.724,8.4,0,14.976,10.525,14.976,23.963s-6.579,23.963-14.976,23.963",
    transform: "translate(-53.574 -451.445)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_117",
    "data-name": "Rectangle 117",
    width: 5.991,
    height: 13.002,
    transform: "translate(98.848 83.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M114.755,539.495c-5.964,0-11.321-4.121-14.693-11.306l5.424-2.545c2.311,4.92,5.777,7.86,9.27,7.86,6.494,0,11.982-9.6,11.982-20.968s-5.488-20.968-11.982-20.968c-4.777,0-9.241,5.3-11.1,13.192l-5.832-1.374c2.553-10.817,9.2-17.808,16.934-17.808,10.077,0,17.972,11.841,17.972,26.958s-7.9,26.958-17.972,26.958",
    transform: "translate(-36.874 -449.633)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallpaperIcon);
export default __webpack_public_path__ + "static/media/wallpaper-icon.521bccb639cc30f12df3717f2de929ad.svg";
export { ForwardRef as ReactComponent };